module.exports = __webpack_public_path__ + "static/ux_6_1_eg-95312a886f4bb7f40097123a2848b29a.png";